import * as ng from 'angular';
import * as _ from 'underscore';

ng.module('e360')
   .directive('userRoles', userRolesDirective);

userRolesDirective.$inject = ['session'];
export function userRolesDirective(session):ng.IDirective {
   return {
      restrict: 'A',
      link: userRolesDirectiveLinkFn
   };

   function userRolesDirectiveLinkFn(scope:ng.IScope, element:JQuery, attrs:ng.IAttributes) {
      scope.$watch(function() {
         return session.getUser();
      }, function(obj) {
         activate();
      });

      function activate() {
         const roles = attrs.userRoles.split(',');
         const isVisible = _.contains(roles, session.getUser().role);
         const readonlyRoles = attrs.userReadonlyRoles ? attrs.userReadonlyRoles.split(',') : [];
         const isReadonly = _.contains(readonlyRoles, session.getUser().role);

         if (isVisible) {
            element.removeClass('ng-hide');
         } else {
            element.addClass('ng-hide');
         }

         if (isReadonly) {
            element.attr('readonly', 'readonly');
         } else {
            element.removeAttr('readonly');
         }
      }

      activate();
   }
}